import { AbstractSocialService } from './AbstractSocialService';
import bridge from '@vkontakte/vk-bridge';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { Singleton } from '@denishussar/html5-game-engine';

@Singleton
export class VKSocialService extends AbstractSocialService {
    showNotification(): Promise<any> {
        return Promise.reject('Not have this method in VK');
    }

    readonly APP_ID = 7979319;//7982066;
    readonly GROUP_ID = 462084990;
    readonly GAME_LINK = 'https://vk.com/app7979319_676657198';

    private userInfo = {};
    private bridgeInitResponse;

    private data: any;

    private tempUrl = new URL('https://beaver-weaver--preview-3umsuxg8.web.app/?api_url=https://api.vk.com/api.php&api_id=7979319&api_settings=0&viewer_id=676657198&viewer_type=2&sid=eafa2d136e83b0acafebe61dbd089603ee9bb73bb2263ae395312ec222421c2f6bcc32db5d3fe5a2996e7&secret=a44d0e3fe9&access_token=786d3440f83fd915eee8c9b9af2de4a6e42cefe1c9f483dc03cb57efa84db0a0311e2f0914954a64c8fbf&user_id=676657198&is_app_user=1&language=3&parent_language=3&is_secure=1&stats_hash=664a2036f151847ef4&is_favorite=0&group_id=0&ads_app_id=7979319_9702d36678499f3249&access_token_settings=&referrer=unknown&lc_name=7b028dc1&platform=web&is_widescreen=0&whitelist_scopes=friends,photos,video,stories,pages,status,notes,wall,docs,groups,stats,market,ads,notifications&group_whitelist_scopes=stories,photos,app_widget,messages,wall,docs,manage&auth_key=f96468dcf019ee8f17447ef3a8c21560&timestamp=1638421207&sign=5SL_0HeJioHmBD_gPb_IqZXh6aJrjYabJqZsjT66HqE&sign_keys=access_token,access_token_settings,ads_app_id,api_id,api_settings,api_url,auth_key,group_id,group_whitelist_scopes,is_app_user,is_favorite,is_secure,is_widescreen,language,lc_name,parent_language,platform,referrer,secret,sid,stats_hash,timestamp,user_id,viewer_id,viewer_type,whitelist_scopes&hash=');


    private url = new URL(window.location.href);

    // get auth_key() {
    //     return this.url.searchParams.get('auth_key');
    // }
    //
    // public async generateAuthToken() {
    //     const signKeys = this.tempUrl.searchParams.get('sign_keys').split(',');
    //     const ordered = {};
    //     signKeys.forEach(key => ordered[key] = this.tempUrl.searchParams.get(key));
    //     console.log(stringify(ordered));
    // }

    async initApp() {
        console.log('VK service init start');
        // this.generateAuthToken();
        const init = await bridge.send('VKWebAppInit');
        console.log('VKWebAppInit');
        const auchToken = await bridge.send(
            'VKWebAppGetAuthToken',
            {
                app_id: this.APP_ID,
                scope: 'friends,status',
            });
        console.log('auchToken');
        this.bridgeInitResponse = await bridge.send('VKWebAppGetUserInfo');
        console.log('bridgeInitResponse', this.bridgeInitResponse);
        this.userInfo = { ...this.bridgeInitResponse, access_token: auchToken['access_token'] };
        return this.userInfo;
    }

    async postMessage(message: string, attachments: string) {
        const postMEssage = await bridge.send('VKWebAppShowWallPostBox', {
            owner_id: this.userInfo['id'],
            message,
            attachments,
        });
    }

    async getFriends() {
        const friends = await bridge.send('VKWebAppCallAPIMethod',
            {
                method: 'friends.get',
                request_id: Math.random(),
                params: {
                    fields: 'first_name,last_name,photo_100',
                    access_token: this.userInfo['access_token'],
                    v: '5.131',
                },
            });
        return friends;
    }

    async getAllowNotification() {
        const notification = await bridge.send('VKWebAppAllowNotifications');
        return notification;
    }

    async showInvite() {
        bridge.send('VKWebAppShowInviteBox', { request_id: Math.random() })
            .then(data => console.log(data.success))
            .catch(error => console.log(error));
    }

    async showInviteOneUser(uid: number) {
        bridge.send('VKWebAppShowRequestBox',
            {
                uid,
                message: 'Привет, посмотри какая классная игра',
                requestKey: `key: ${Math.random()}`,
            })
            .then(data => console.log(data.success))
            .catch(error => console.log(error));
    }

    async addToFavorite() {
        const data = await bridge.send('VKWebAppAddToFavorites');
        return data;
    }

    async joinGroup() {
        bridge.send('VKWebAppJoinGroup', { 'group_id': this.GROUP_ID })
            .then(data => console.log(data.result))
            .catch(error => console.log(error));
    }

    public getToken() {
        console.log('getToken vk');
        const params = this.url.searchParams.toString();
        return httpsCallable<{
            params: string,
            sign: string,
        }, string>(getFunctions(), 'getTokenForVK')({
            params: params, //@ts-ignore //todo: add normal types
            sign: this.userInfo.sign,
        });
    }
}